import { render, staticRenderFns } from "./SponsorsSelector.vue?vue&type=template&id=7b33855a&scoped=true"
import script from "./SponsorsSelector.vue?vue&type=script&lang=js"
export * from "./SponsorsSelector.vue?vue&type=script&lang=js"
import style0 from "./SponsorsSelector.vue?vue&type=style&index=0&id=7b33855a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b33855a",
  null
  
)

export default component.exports